import React from 'react';
import { DateTime } from 'luxon';
import EquipmentList from './EquipmentList';
import { AnimateList } from './AnimateEquipmentList';
import SystemsList from './SystemsList';
import StatusCenterTabs  from './StatusCenterTabs';
import { eq } from 'lodash';

const StatusCenter = ({ equipmentList, equipmentStatuses, systemsList, systemStatuses, isVisible }) => {
  const equipmetStatuses = equipmentStatuses.filter((item) => item.status === 'not_running');

  const equipmentListComponent = () => (
      <EquipmentList
        list={equipmentList}
        statuses={equipmetStatuses}
      />
  );


  const systemsListComponent = () => (
    <SystemsList
      list={systemsList}
      statuses={systemStatuses.filter((item) => item.status === 'not_running')}
    />
);
  
  const tabs = [
    {label: 'Equipment', content:equipmentListComponent},
    {label: 'Systems', content:systemsListComponent},
  ]

  return (
    <div className="equipment-lists" data-toggle={isVisible}>
      <StatusCenterTabs equipmentEno={equipmentStatuses.length} systemsOoo={systemStatuses.length} tabs={tabs} className="tabContainer" />
    </div>
  );
};

export default StatusCenter;
